import React, { useMemo, useState, useEffect } from "react";
import Customtable from "../../helper/Customtable";
import Swal from 'sweetalert2';
import { post } from "../../helper/api_helper"

const User = () => {
    const initialFormState = {
        user_id: 0,
        role_id_fk:'',
        username: '',
        password:'',
        status: '0'
    };

    const [formData, setFormData] = useState(initialFormState);
    const [validated, setValidated] = useState(false);
    const [userList, setuserList] = useState([]);
    const [roleList, setroleList] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                label_condition: 's_no',
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: 'Actions',
                cell: ({ row }) => (
                    <>
                        <i
                            className="ri-file-edit-fill text-primary cursor-pointer me-2"
                            onClick={() => handleEdit(row)}
                            title="Edit"
                            style={{ fontSize: "18px" }}
                        />
                    </>
                ),
                enableSorting: false,
                enableColumnFilter: false,
            },
            {
                header: 'Username',
                accessorKey: 'username',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Role Name',
                accessorKey: 'role_name',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Password',
                accessorKey: 'password',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Status',
                accessorKey: 'status',
                enableColumnFilter: false,
                enableSorting: true,
                label_condition: 'status',
            },
        ],
        []
    );

    const handleEdit = (row) => {

        setFormData({
            user_id: row.user_id,
            role_id_fk : row.role_id_fk,
            username: row.username,
            password: row.password,
            status: row.status
        });
    };


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const showAlert = (icon, title, text, timer = 2000) => {
        Swal.fire({ icon, title, text: text || 'Something went wrong.', timer, showConfirmButton: false });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
            showAlert('error', 'Oops...', 'Please fill in all required fields.');
            setValidated(true);
        } else {
            try {
                setValidated(false);
                const response = await post("/settings/user", formData);
                if (response.status === 200) {
                    showAlert('success', 'Saved', response.message);
                    fetchData();
                    setFormData(initialFormState);
                } else {
                    showAlert('error', response.status, response.message);
                }
            } catch (err) {
                showAlert('error', 'Unexpected Error', err.message);
            }
        }
    };

    const handleReset = () => {
        setFormData(initialFormState);
        setValidated(false);
    };

    const fetchData = async () => {
        try {
            const response = await post("/settings/user_list");
            if (response.status === 200) {
                setuserList(response.data);
            } else {
                showAlert('error', response.status, response.message);
            }
        } catch (err) {
            showAlert('error', 'Unexpected Error', err.message);
        }
    };

    const fetchRoleData = async () => {
        try {
            const response = await post("/settings/role_list");
            if (response.status === 200) {
                setroleList(response.data);
            } else {
                showAlert('error', response.status, response.message);
            }
        } catch (err) {
            showAlert('error', 'Unexpected Error', err.message);
        }
    };

    useEffect(() => {
        fetchData();
        fetchRoleData();
    }, []);

    return (
        <div className="row">
            <div className="col-lg-3">
                <div className="card">
                    <form noValidate className={validated ? "was-validated" : ""} onSubmit={handleSubmit}>
                    <div className="card-header">
                        <h5 className="card-title mb-0">USER</h5>
                    </div>
                    <div className="card-body">
                        <div className="row g-3">
                            <div className="col-md-12">
                                <label>Username</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="username"
                                    name="username"
                                    value={formData.username}
                                    onChange={handleChange}
                                    required
                                    placeholder="user"
                                />
                            </div>
                             <div className="col-md-12">
                                <label>Role Name</label>
                                <select
                                    name="role_id_fk"
                                    className="form-control radius-4 form-select"
                                    value={formData.role_id_fk}
                                    onChange={handleChange}
                                >
                                    <option value="">Select</option>
                                    {roleList.map((role) => (
                                        <option key={role.role_id} value={role.role_id}>
                                        {role.role_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-12">
                                <label>Password</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                    placeholder="Password"
                                />
                            </div>

                            <div className="col-md-12">
                                <label>Status</label>
                                <select
                                    className="form-control radius-8 form-select"
                                    id="status"
                                    name="status"
                                    value={formData.status}
                                    onChange={handleChange}
                                    required
                                >
                                    <option value="" disabled>Select</option>
                                    <option value="0">Active</option>
                                    <option value="1">In-Active</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                        <div className="col-md-12">
                            <button type="submit" className="btn btn-primary btn-sm" style={{ float: "right"}}>SAVE</button>
                            <button type="button" onClick={handleReset} className="btn btn-sm btn-secondary">Clear</button>
                        </div>
                        </div>
                    </div>
                    </form>
                </div>
            </div>
            <div className="col-lg-9">
                <div className="card basic-data-table">
                    <div className="card-header">
                    <h5 className="card-title mb-0">User List</h5>
                    </div>
                    <div className="card-body">
                    <Customtable
                        table_title="User List"
                        columns={columns}
                        data={userList}
                        isGlobalFilter={true}
                        isPagination={true}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        isExportButton={true}
                    />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default User;
